import { createRouter, createWebHashHistory } from 'vue-router'
import cookie from '@/utils/cookie'
import config from '@/api/config'

const routes = [
  {
    path: '/',
    name: 'dashboard',
    meta: { title: '后台管理', requiresAuth: true },
    component: () => import('@/views/dashboard/ContainerView.vue'),
    redirect: '/home',
    children: [
      { path: '/home', name: 'home', meta: { title: '仪表盘', requiresAuth: true }, component: () => import('@/views/dashboard/HomeView.vue') },
      { path: '/roles', name: 'roles', meta: { title: '角色管理', requiresAuth: true }, component: () => import('@/views/roles/RolesView.vue') },
      { path: '/menus', name: 'menus', meta: { title: '菜单管理', requiresAuth: true }, component: () => import('@/views/menus/MenusView.vue') },
      { path: '/admin', name: 'admin', meta: { title: '管理员管理', requiresAuth: true }, component: () => import('@/views/admin/AdminView.vue') },
      { path: '/system', name: 'system', meta: { title: '系统管理', requiresAuth: true }, component: () => import('@/views/system/SystemView.vue') },
      { path: '/attachment', name: 'attachment', meta: { title: '附件管理', requiresAuth: true }, component: () => import('@/views/attachment/AttachmentView.vue') },
      { path: '/banner', name: 'banner', meta: { title: '轮播图管理', requiresAuth: true }, component: () => import('@/views/banner/BannerView.vue') },
      { path: '/notice', name: 'notice', meta: { title: '公告管理', requiresAuth: true }, component: () => import('@/views/notice/NoticeView.vue') },
      { path: '/union', name: 'union', meta: { title: '工会条例', requiresAuth: true }, component: () => import('@/views/union/UnionView.vue') },
      { path: '/glory', name: 'glory', meta: { title: '荣耀展示', requiresAuth: true }, component: () => import('@/views/glory/GloryView.vue') },
      { path: '/curriculumClassify', name: 'curriculumClassify', meta: { title: '课程分类', requiresAuth: true }, component: () => import('@/views/curriculum/CurriculumClassifyView.vue') },
      { path: '/curriculum', name: 'curriculum', meta: { title: '课程列表', requiresAuth: true }, component: () => import('@/views/curriculum/CurriculumView.vue') },
      { path: '/shopCategory', name: 'shopCategory', meta: { title: '商城分类', requiresAuth: true }, component: () => import('@/views/shop/ShopCategoryView.vue') },
      { path: '/shop', name: 'shop', meta: { title: '商城列表', requiresAuth: true }, component: () => import('@/views/shop/ShopView.vue') },
      { path: '/ranking', name: 'ranking', meta: { title: '排行榜', requiresAuth: true }, component: () => import('@/views/ranking/RankingView.vue') },
      { path: '/user', name: 'user', meta: { title: '用户列表', requiresAuth: true }, component: () => import('@/views/user/UserView.vue') },
      { path: '/applyUser', name: 'applyUser', meta: { title: '待审核用户', requiresAuth: true }, component: () => import('@/views/user/ApplyUserView.vue') },
      { path: '/about', name: 'about', meta: { title: '关于我们', requiresAuth: true }, component: () => import('@/views/about/AboutView.vue') },
      { path: '/groupLiveStandard', name: 'groupLiveStandard', meta: { title: '团播规范', requiresAuth: true }, component: () => import('@/views/groupLiveStandard/GroupLiveStandardView.vue') },
      { path: '/promotion', name: 'promotion', meta: { title: '晋升', requiresAuth: true }, component: () => import('@/views/promotion/PromotionView.vue') },
      { path: '/courseBook', name: 'courseBook', meta: { title: '课程预约', requiresAuth: true }, component: () => import('@/views/courseBook/CourseBookView.vue') },
      { path: '/userMessages', name: 'userMessages', meta: { title: '用户信息', requiresAuth: true }, component: () => import('@/views/userMessages/UserMessagesView.vue') },
      { path: '/shopOrder', name: 'shopOrder', meta: { title: '兑换列表', requiresAuth: true }, component: () => import('@/views/shop_order/ShopOrderView.vue') },
      { path: '/complaintsSuggestions', name: 'complaintsSuggestions', meta: { title: '投诉建议', requiresAuth: true }, component: () => import('@/views/complaintsSuggestions/ComplaintsSuggestionsView.vue') },
      { path: '/404', name: 'Error400', meta: { title: '404', requiresAuth: false }, component: () => import('@/views/error/404.vue') },
      { path: '/500', name: 'Error500', meta: { title: '500', requiresAuth: false }, component: () => import('@/views/error/500.vue') }
    ]
  },
  { path: '/login', name: 'login', meta: { title: '登录', requiresAuth: false }, component: () => import('@/views/login/LoginView.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/404' }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 动态添加路由
// router.addRoute('dashboard', {
//   name: 'about4',
//   path: '/about4',
//   component: () => import('@/views/about/AboutView4.vue')
// })

// 请求前处理
router.beforeEach((to, from, next) => {
  if (to.meta?.title) {
    // 设置标题
    document.title = to.meta.title
  }
  if (to.matched.some((record) => record.meta?.requiresAuth || false)) {
    if (!cookie.getCookie(config.getTokenFiled())) {
      return next({ path: '/login', replace: true, query: { redirect: to.fullPath } })
    }
    return next()
  } else {
    return next()
  }
})
// 后置路由处理
// router.afterEach((to, from) => {
//   console.log(to, from);
// });
export default router
